import React from 'react'
import Header from '../Landing/Header/Header'
import "./termscondition.scss";
import Luckify from '../Landing/Luckify/Luckify';
import Footer from '../Landing/Footer/Footer';

const Termscondition = () => {
    return (
        <>
            <Header />
            <div className='terms_mains'>
                <section className='inner_privacy'>
                    <div className='inner_text'>
                        <h2>Terms & Conditions</h2>
                        <h3>Effective Date: 30.06.2025</h3>
                    </div>

                    <video
                        className="main-banner-video"
                        muted="muted"
                        playsinline="playsinline"
                        autoPlay
                        loop
                        width="100%"
                        id="myVideo"
                    >
                        <source src="/assets/bannerassets/luckifybg.mp4" type="video/mp4" />
                    </video>
                    <img
                        src="/assets/bannerassets/bannertopshade.png"
                        alt="bannertopshade"
                        className="bannertopshade"
                    />
                    {window.innerWidth < 991 ?
                        <img
                            src="/assets/bannerassets/bannerlinesmbl.png"
                            alt="bannerlines"
                            className="bannerlines"
                        />
                        :
                        <img
                            src="/assets/bannerassets/bannerlines.png"
                            alt="bannerlines"
                            className="bannerlines"
                        />
                    }
                </section>
                <div className='bottom_data'>
                    <div className='custom-container'>
                        <h4>1. Introduction</h4>
                        <p>These Terms and Conditions (“Terms”) govern your access to and use of the website https://www.luckify.bet/ (“Site”) and the decentralized gaming services provided by Luckify (“Luckify”, “we”, “our”, or “us”). By accessing or using the Site, you agree to be bound by these Terms.</p>
                        <h4>2. Eligibility</h4>
                        <h6>2.1 - You must be at least 18 years of age and have the legal capacity to enter into these Terms under the laws of your jurisdiction.</h6>
                        <h6>2.2 - You are not eligible to use the Site or services if you are located in, incorporated in, or a citizen or resident of the United States, United Kingdom, or Israel.</h6>
                        <p>2.3 - By accessing the Site, you represent and warrant that you are not located in any jurisdiction where participation in blockchain-based gaming or the use of cryptocurrency is prohibited by applicable law</p>

                        <h4>3. Services</h4>
                        <h6>3.1 - Luckify provides access to decentralized, provably fair games powered by a Verifiable Randomness Engine integrating Chainlink VRF and real-time token economics.</h6>
                        <h6>3.2 - The platform operates using the LUCK token, which is used for randomness fees, staking, governance, and rewards.</h6>
<h6>3.3 - Services include loot boxes, PvP games, lotteries, and randomness-as-a-service via SDK/API.</h6>

                        <h4>4. User Responsibilities </h4>
                        <h6>4.1 - You agree to use the Site only for lawful purposes and in accordance with these Terms.</h6>
<h6>4.2 - You shall not attempt to interfere with or compromise the integrity or security of any systems operated by Luckify.</h6>
<h6>4.3 - You must ensure any wallet you connect is your own and under your control.</h6>

                        <h4>5. Risk Disclosure</h4>
                        <h6>5.1 - Participation in decentralized gaming involves significant risk, including but not limited to the volatility of digital assets, the risk of smart contract failure, and potential regulatory change</h6>
<p>5.2 - You acknowledge that Luckify does not guarantee any winnings or earnings and that gameplay outcomes are subject to probabilistic outcomes determined on-chain</p>





                        <h4>6. Intellectual Property</h4>
                        <p>All content on the Site, including trademarks, graphics, and technology, is the property of Luckify or its licensors and may not be used without prior written consent.</p>


                        <h4>4. Use of Data</h4>
                        <p>We use your information solely to: - Enable interaction withdecentralized games and randomness tools; - Ensure platform integrity and prevent abuse; - Respond to user inquiries; - Comply with applicable legal and regulatory obligations.</p>


                        <h4>7. Compliance</h4>
                        <h6>7.1 - You agree not to use the Site or its services for any activity that may be deemed unlawful, including money laundering or terrorist financing</h6>
                        <p>7.2 - Luckify reserves the right to restrict access or take necessary compliance action to prevent illicit use.</p>




                        <h4>Limitation</h4>
                        <h6>8.1 - YThe services are provided “as is” and without warranties of any kind, whether express or implied</h6>
                        <p>8.2 - Luckify is not liable for any indirect, incidental, or consequential damages arising from your use of the Site or services.</p>


                        <h4>9. Indemnity</h4>
                        <p>You agree to indemnify and hold harmless Luckify, its affiliates, and contributors from any claims, losses, or liabilities arising from your use of the Site or violation of these Terms.</p>



                        <h4>10. Termination</h4>
                        <p>Luckify may suspend or terminate your access to the Site at any time without notice if you violate these Terms.</p>



                        <h4>11. Governing Law</h4>
                        <p>These Terms shall be governed by the laws of British Virgin Islands, without regard to conflict of laws principle</p>



                        <h4>12. Amendments</h4>
                        <p>Luckify reserves the right to amend these Terms at any time. Changes will be posted on the Site and effective upon posting</p>

                        <h4>13. Contact</h4>
                        <p>For any questions about these Terms, contact: <a href="mailto:info@luckify.bet">info@luckify.bet</a></p>
                    </div>

                </div>
            </div>
            <Footer/>
        </>
    )
}

export default Termscondition
